<template >
    <div class="coupon-list">
        <div class="coupon" v-for="(item, index) in coupons" :key="index" @click="clickCoupon(item)">{{ item.name }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        coupons: Array,
    },
    data () {
        return {

        }
    },
    methods: {
        clickCoupon (coupon) {
            this.$emit('onClick', function () {
                return coupon
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.coupon-list {
    display: flex;
    flex-wrap: wrap;

    .coupon {
        width: max-content;
        height: 0.53rem;
        border: 0.01rem solid rgba(255, 106, 77, 0.4);
        border-radius: 0.05rem;
        padding: 0 .13rem;
        box-sizing: border-box;
        line-height: .53rem;
        color: #FF6A4D;
    }
}
</style>